import React from "react";
import {
	IconListSearch,
	IconBriefcase,
	IconUsersGroup,
	IconFile,
	IconPlus,
	IconSettings,
	IconDownload,
} from "@tabler/icons-react";
import { settingsRoutes } from "../../config/routes";
import { Divider } from "@mantine/core";

const stylePropsForIcons = {
	verticalAlign: "sub",
	marginRight: 10,
	position: "absolute",
	color: "var(--lxw-main-500)",
};

export const dividerOption = {
	label: <Divider />,
	type: "divider",
	isDisabled: true,
};

export const SearchBoxOptionsTypeMap = {
	search: {
		iconComponent: <IconListSearch size={16} style={stylePropsForIcons} />,
	},
	matter: {
		iconComponent: <IconBriefcase size={16} style={stylePropsForIcons} />,
	},
	client: {
		iconComponent: <IconUsersGroup size={16} style={stylePropsForIcons} />,
	},
	document: {
		iconComponent: <IconFile size={16} style={stylePropsForIcons} />,
	},
	createMatter: {
		iconComponent: <IconPlus size={16} style={stylePropsForIcons} />,
	},
	createClient: {
		iconComponent: <IconPlus size={16} style={stylePropsForIcons} />,
	},
	createDocument: {
		iconComponent: <IconPlus size={16} style={stylePropsForIcons} />,
	},
	divider: {
		iconComponent: null,
	},
	settings: {
		iconComponent: <IconSettings size={16} style={stylePropsForIcons} />,
	},
	downloadLauncher: {
		iconComponent: <IconDownload size={16} style={stylePropsForIcons} />,
	},
};

export const formatMatterOptions = (response) => {
	const matterOptions = response?.mysql?.matterResults
		? response?.mysql?.matterResults.map((x) => ({
				label: (
					<div>
						<div>
							{x.matchViaCustomMatterID
								? `Open Matter with Custom ID "${x.customMatterID}" (${x.name})`
								: `Open "${x.name}" Matter`}
						</div>
						{x.clientName && (
							<div
								style={{
									fontSize: "smaller",
									color: "gray",
								}}
							>{`Client: ${x.clientName}`}</div>
						)}
					</div>
				),
				sublabel: `Client: ${x.clientName}`,
				value: x.id,
				type: "matter",
			}))
		: [];
	return matterOptions;
};
export const formatClientOptions = (response) => {
	const clientOptions = response?.mysql?.clientResults
		? response?.mysql?.clientResults.map((x) => ({
				label: `Open "${x.name}" Client`,
				value: x.id,
				type: "client",
			}))
		: [];
	return clientOptions;
};

export const formatDocumentOptions = (response) => {
	const documentOptions = response?.mysql?.documentResults
		? response?.mysql?.documentResults.map((x) => ({
				label: (
					<div>
						{x.foundViaDocumentID
							? `Open Document ID ${x.id} (${x.name})`
							: `Open "${x.name}" Document`}
						{x.matterName || x.firmDocsNamespace ? (
							<div
								style={{
									fontSize: "smaller",
									color: "gray",
								}}
							>
								{x.matterName || x.firmDocsNamespace}
							</div>
						) : null}
					</div>
				),
				sublabel: `${x.matterName ? x.matterName : x.firmDocsNamespace ? x.firmDocsNamespace : "Unknown"}`,
				value: x.id,
				type: "document",
			}))
		: [];
	return documentOptions;
};

export const getSettingsOptions = ({
	inputValue,
	hasPermissionsAccess,
	launcherURL,
	userRights,
}) => {
	let settingsMatches = [];
	const lowerInput = inputValue.toLowerCase();
	Object.keys(settingsRoutes).forEach((key) => {
		const route = settingsRoutes[key];
		if (settingsMatches.length > 3) {
			// once we have 3 matches, stop checking further
			return;
		}
		if (
			(route.requireAdmin && !hasPermissionsAccess) ||
			userRights[route.requiredRight] === false
		) {
			// if requires admin permissions but user doesn't have them, skip
			return;
		}
		if (
			route.keywords.some((kw) => kw.toLowerCase().includes(lowerInput))
		) {
			if (route.action === "downloadLauncher" && launcherURL) {
				// Special case for launcher download link
				settingsMatches.push({
					label: route.label,
					value: launcherURL,
					type: "downloadLauncher",
				});
				return;
			}
			settingsMatches.push({
				label: `Go to Setting > ${route.label}`,
				value: route.href,
				type: "settings",
			});
		}
	});
	return settingsMatches;
};

export const searchOptionsNoSearchString = ({ searchMenuOptions }) => {
	return searchMenuOptions.map((s) => {
		return {
			label: s.placeholder,
			value: s.querystring,
			type: "search",
		};
	});
};
export const searchOptionsWithSearchString = ({
	searchString,
	searchMenuOptions,
}) => {
	return searchMenuOptions.map((s) => {
		return {
			label: `${s.placeholder} for "${searchString}"`,
			value: s.querystring,
			type: "search",
		};
	});
};
